/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Button from 'flarum/common/components/Button';
import AbstractCreateReviewButton from './AbstractCreateReviewButton';

/**
 * The primary "write a review" control: index and tag heroes, the reviews page, the home and
 * article review lists. `IndexPage-newReview` carries the styling, TagHero colours included.
 */
export default class CreateReviewPrimaryButton extends AbstractCreateReviewButton {
	view() {
		return (
			<Button
				icon="fas fa-edit"
				className="Button Button--large IndexPage-newReview"
				itemClassName="App-primaryControl"
				onclick={() => this.start()}
				disabled={!this.allowed()}
			>
				{this.label()}
			</Button>
		);
	}
}
